export default "__VITE_ASSET__BgKMldOI__"